import { UserPermissions, UserType } from "healthex-common/user.dtos";
import { indexBy } from "healthex-common/utils";
import { NamedRoutes } from "./NamedRoutes";
const anyOrgAdmin = [
    { userType: UserType.HEALTHCARE_ORGANIZATION, permissions: [UserPermissions.ORG_ADMIN] },
    { userType: UserType.EXTERNAL_RESEARCHER, permissions: [UserPermissions.ORG_ADMIN] },
    { userType: UserType.SERVICE_PROVIDER, permissions: [UserPermissions.ORG_ADMIN] },
];
const routeAuthConfig = [
    { route: NamedRoutes.HEALTHCARE_ORG_ANALYTICS, restrictedTo: [UserType.HEALTHCARE_ORGANIZATION, UserType.SERVICE_PROVIDER] },
    {
        route: NamedRoutes.PROJECTS,
        restrictedTo: [UserType.EXTERNAL_RESEARCHER, UserType.HEALTHCARE_ORGANIZATION],
    },
    { route: NamedRoutes.PATIENT_HOME_ONBOARDING, restrictedTo: [UserType.PATIENT, UserType.SCREENSHOT_USER] },
    { route: NamedRoutes.PATIENT_MY_HEALTHEX, restrictedTo: [UserType.PATIENT, UserType.SCREENSHOT_USER] },
    { route: NamedRoutes.PATIENT_STUDIES, restrictedTo: [UserType.PATIENT] },
    {
        route: NamedRoutes.GLOBAL_ADMIN,
        restrictedTo: [{ userType: UserType.SERVICE_PROVIDER, permissions: [UserPermissions.GLOBAL_PROVISIONING] }],
    },
    {
        route: NamedRoutes.PROJECTS_PROJECT_MANAGER,
        restrictedTo: [
            { userType: UserType.HEALTHCARE_ORGANIZATION, permissions: [UserPermissions.RESEARCHER] },
            { userType: UserType.EXTERNAL_RESEARCHER, permissions: [UserPermissions.RESEARCHER] },
        ],
    },
    { route: NamedRoutes.ADMIN_ORG_SETTINGS, restrictedTo: anyOrgAdmin },
    { route: NamedRoutes.ADMIN_USERS, restrictedTo: anyOrgAdmin },
    {
        route: NamedRoutes.ADMIN_DATA_SETTINGS,
        restrictedTo: [
            { userType: UserType.HEALTHCARE_ORGANIZATION, permissions: [UserPermissions.ORG_ADMIN, UserPermissions.RESEARCH_ADMIN] },
            { userType: UserType.EXTERNAL_RESEARCHER, permissions: [UserPermissions.ORG_ADMIN, UserPermissions.RESEARCH_ADMIN] },
        ],
    },
    {
        route: NamedRoutes.ADMIN_DATA_POLICY,
        restrictedTo: [
            { userType: UserType.HEALTHCARE_ORGANIZATION, permissions: [UserPermissions.ORG_ADMIN, UserPermissions.RESEARCH_ADMIN] },
        ],
    },
    {
        route: NamedRoutes.ADMIN_RESEARCH_SETTINGS,
        restrictedTo: [
            { userType: UserType.HEALTHCARE_ORGANIZATION, permissions: [UserPermissions.RESEARCH_ADMIN] },
            { userType: UserType.EXTERNAL_RESEARCHER, permissions: [UserPermissions.ORG_ADMIN] },
        ],
    },
    {
        route: NamedRoutes.ADMIN_PATIENT_SETTINGS,
        restrictedTo: [{ userType: UserType.HEALTHCARE_ORGANIZATION, permissions: [UserPermissions.RESEARCH_ADMIN] }],
    },
    { route: NamedRoutes.ADMIN_APIKEYS, restrictedTo: anyOrgAdmin },
    {
        route: NamedRoutes.PATIENT_CONSENT_ENROLLMENT,
        restrictedTo: [UserType.PATIENT, UserType.SCREENSHOT_USER],
    },
    {
        route: NamedRoutes.GUIDED_PATIENT_CONSENT_ENROLLMENT,
        restrictedTo: [UserType.SCREENSHOT_USER, { userType: UserType.HEALTHCARE_ORGANIZATION, permissions: [UserPermissions.PROVIDER] }],
    },
    {
        route: NamedRoutes.PREREAD_PATIENT_CONSENT_ENROLLMENT,
        restrictedTo: [UserType.PATIENT],
    },
    { route: NamedRoutes.PATIENT_MY_HEALTHEX, restrictedTo: [UserType.PATIENT] },
    { route: NamedRoutes.WELCOME_ORG_USER_DETAILS, restrictedTo: [UserType.HEALTHCARE_ORGANIZATION, UserType.EXTERNAL_RESEARCHER] },
    { route: NamedRoutes.WELCOME_BASIC_ORG_DETAILS, restrictedTo: [UserType.HEALTHCARE_ORGANIZATION, UserType.EXTERNAL_RESEARCHER] },
    { route: NamedRoutes.WELCOME_CUSTOMIZE_ORG_DETAILS, restrictedTo: [UserType.HEALTHCARE_ORGANIZATION, UserType.EXTERNAL_RESEARCHER] },
];
export class RoutingAuthUIManager {
    constructor(authManager, routingUIManager) {
        this.authManager = authManager;
        this.routingUIManager = routingUIManager;
        this.routeIndex = indexBy(routeAuthConfig, (item) => item.route.routeName);
        this.routingUIManager.registerRedirectInterceptor((route) => {
            if (!this.isRouteAuthorized(route)) {
                console.log(`User is not authorized for route ${route.routeName}, redirecting`);
                return NamedRoutes.INDEX;
            }
            return null;
        });
    }
    isRouteAuthorized(route) {
        const routeRestrictions = this.findRelevantRouteRestrictions(route);
        if (!routeRestrictions) {
            return true;
        }
        if (!this.authManager.userType) {
            return true;
        }
        return routeRestrictions.some((restriction) => {
            if (typeof restriction === "object") {
                return (restriction.userType === this.authManager.userType &&
                    restriction.permissions.some((requiredPermission) => this.authManager.permissions.includes(requiredPermission)));
            }
            else {
                return restriction === this.authManager.userType;
            }
        });
    }
    findRelevantRouteRestrictions(route) {
        const exactMatch = this.routeIndex[route.routeName];
        if (exactMatch) {
            return exactMatch.restrictedTo;
        }
        else if (route.parent) {
            return this.findRelevantRouteRestrictions(route.parent);
        }
        else {
            return null;
        }
    }
}
